module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0",
      "height": "auto !important"
    }
  }, [_c('div'), _vm._v(" "), (_vm.row.step == 1) ? _c('div', [_c('div', {
    staticClass: "huiyi-box-title",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_vm._v("第一步：请选择您要报名的项目")]), _vm._v(" "), _c('div', {
    staticClass: "baoming-item-box"
  }, _vm._l((_vm.row.group_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "baoming-item",
      style: (_vm.getBackground(item, index)),
      on: {
        "click": function($event) {
          return _vm.onGroupBtn(item, index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n            ")])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("下一步")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.row.step == 2) ? _c('div', [_c('van-cell-group', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{name:'HuiyiApplyList'}"
    }],
    attrs: {
      "is-link": "",
      "title": "我的会议培训报名记录"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return undefined
      },
      proxy: true
    }], null, false, 157076738)
  }), _vm._v(" "), (false) ? _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyList'
      }),
      expression: "{name:'ISaiApplyList'}"
    }],
    attrs: {
      "is-link": "",
      "title": "我的赛事报名记录"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return undefined
      },
      proxy: true
    }], null, false, 157076738)
  }) : _vm._e()], 1), _vm._v(" "), (_vm.row.check_types.indexOf(1) > -1 || _vm.row.check_types.indexOf(2) > -1) ? _c('div', {
    staticClass: "huiyi-box-title",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_vm._v("4月10日开始场次")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "huiyi-group-item-box"
  }, _vm._l((_vm.row.doing), function(irow, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.row.check_types.indexOf(index + 1) > -1 && index < 2),
        expression: "row.check_types.indexOf(index+1)>-1 && index<2"
      }, {
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'HuiyiApplyFormStep1',
          query: {
            saiqu_id: irow.id
          },
        }),
        expression: "{\n            name: 'HuiyiApplyFormStep1',\n            query: { saiqu_id: irow.id },\n            }"
      }],
      key: index,
      staticClass: "train-items"
    }, [_c('div', {
      staticClass: "train-items-top items-top1",
      style: ('background-image: linear-gradient(to right, #' +
        irow.color[0] +
        ' , #' +
        irow.color[1] +
        ');')
    }, [_c('div', [_c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(irow.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(irow.date_str))])])]), _vm._v(" "), _c('div', {
      staticClass: "train-items-title"
    }, [_vm._v(_vm._s(irow.name))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between"
    }, [_c('div', {
      staticClass: "train-items-time"
    }, [_vm._v(_vm._s(irow.startdate))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-address"
    }, [_vm._v("\n                " + _vm._s(irow.province) + "·" + _vm._s(irow.city) + "\n            ")])])])
  }), 0), _vm._v(" "), (_vm.row.check_types.indexOf(1) > -1 || _vm.row.check_types.indexOf(2) > -1) ? _c('div', {
    staticClass: "huiyi-box-title",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_vm._v("4月11日开始场次（如果有人员同时报10号开始的场次，为了避免重复缴纳食宿费，请先报名10号开始的场次，之后再报名11号开始的场次）")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "huiyi-group-item-box"
  }, _vm._l((_vm.row.doing), function(irow, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.row.check_types.indexOf(index + 1) > -1 && index >= 2),
        expression: "row.check_types.indexOf(index+1)>-1 && index>=2"
      }],
      key: index,
      staticClass: "train-items",
      on: {
        "click": function($event) {
          return _vm.go2(irow)
        }
      }
    }, [_c('div', {
      staticClass: "train-items-top items-top1",
      style: ('background-image: linear-gradient(to right, #' +
        irow.color[0] +
        ' , #' +
        irow.color[1] +
        ');')
    }, [_c('div', [_c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(irow.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(irow.date_str))])])]), _vm._v(" "), _c('div', {
      staticClass: "train-items-title"
    }, [_vm._v(_vm._s(irow.name))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between"
    }, [_c('div', {
      staticClass: "train-items-time"
    }, [_vm._v(_vm._s(irow.startdate))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-address"
    }, [_vm._v("\n                " + _vm._s(irow.province) + "·" + _vm._s(irow.city) + "\n            ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "native-type": "button",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.row.step = 1
      }
    }
  }, [_vm._v("上一步\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6d221e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/331/ApplyFormStep1.vue
// module id = 2496
// module chunks = 0